import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchemaEn from './stepsSchema';
import { DIET_TYPES } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/diet-settings/nutritionSettings/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchemaEn}
        currentMainStep="nutritionSettings"
        dietTypes={DIET_TYPES}
      />
    ),
    private: true,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
